export const SHOW_RSVP_FORM = 'SHOW_RSVP_FORM';
export const TOGGLE_RSVP_FORM_VISIBLE  = 'TOGGLE_RSVP_FORM_VISIBLE';
export const SET_FORM_SUBMITTING = 'SET_FORM_SUBMITTING';
export const SET_INCOMPLETE_GUEST = 'SET_INCOMPLETE_GUEST';
export const SET_NOT_YOU = 'SET_NOT_YOU';
export const UNSET_NOT_YOU = 'UNSET_NOT_YOU';
export const SET_EDITING_GUEST_NAME = 'SET_EDITING_GUEST_NAME';
export const SET_GUEST_NAME = 'SET_GUEST_NAME';
export const SET_ALT_GUEST_NAME = 'SET_ALT_GUEST_NAME';
export const SET_GUEST_EMAIL = 'SET_GUEST_EMAIL';
export const SET_TOTAL_ADULTS = 'SET_TOTAL_ADULTS';
export const SET_TOTAL_KIDS = 'SET_TOTAL_KIDS';
export const SET_NOTIFY_MARKETING = 'SET_NOTIFY_MARKETING';
export const SET_RSVP_COMMENT = 'SET_RSVP_COMMENT';
export const SET_RSVP_RESPONSE = 'SET_RSVP_RESPONSE';
export const SET_PLUSONE_EMAILS = 'SET_PLUSONE_EMAILS';
export const SET_PLUSONE_EDIT_TEXT = 'SET_PLUSONE_EDIT_TEXT';
export const TOGGLE_CHANGE_RSVP_VISIBLE = 'TOGGLE_CHANGE_RSVP_VISIBLE'



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/rsvp/constants.es6